<template>
  <affix>
    <template v-if="$route.path.indexOf('/application/') > -1 || $route.name == 'client-activity' || $store.state.view == 'client'">
      <ApplicationNavigation />
    </template>

    <template v-if="$route.path.indexOf('/broker/') > -1">
      <BrokerNavigation />
    </template>

    <template v-if="$route.path.indexOf('/help/') > -1 && $store.state.view =='broker'">
      <HelpNavigation />
    </template>
  </affix>
</template>

<script>
  import ApplicationNavigation  from './ApplicationNavigation'
  import BrokerNavigation       from './BrokerNavigation';
  import HelpNavigation         from './HelpNavigation';
  import Affix                  from 'easy-affix'

  export default {
    components: {
      ApplicationNavigation,
      BrokerNavigation,
      HelpNavigation,
      Affix
    },
  }
</script>